import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { generateCvHtml } from '../utils/generateCvHtml';
import { Link } from 'react-router-dom';

function CVDownload() {
  const { lang, t } = useLanguage();

  const handleDownloadCV = () => {
    try {
      const cvWindow = window.open('', '_blank');
      if (cvWindow) {
        const html = generateCvHtml(lang);
        cvWindow.document.open();
        cvWindow.document.write(html);
        cvWindow.document.close();
      } else {
        // Fallback if popup blocker intercepted
        window.location.href = lang === 'ar' ? '/ar/cv' : '/cv';
      }
    } catch (err) {
      console.error('Error opening CV window:', err);
      window.location.href = lang === 'ar' ? '/ar/cv' : '/cv';
    }
  };

  const cvRoute = lang === 'ar' ? '/ar/cv' : '/cv';

  return (
    <div className="flex flex-col sm:flex-row items-center gap-3">
      {/* Primary Action: Direct Download / Print Window */}
      <button
        onClick={handleDownloadCV}
        className="w-full sm:w-auto px-7 py-3.5 rounded-2xl bg-primary-500 text-black font-bold hover:bg-primary-400 transition-all shadow-lg shadow-primary-500/20 transform hover:scale-[1.02] active:scale-[0.98] flex items-center justify-center gap-3 group"
        title={lang === 'ar' ? 'فتح وطباعة السيرة الذاتية كملف PDF' : 'Open and print Executive CV as PDF'}
      >
        <svg className="w-5 h-5 group-hover:scale-110 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
        <span>{t('sections.cvDownloadButton') || (lang === 'ar' ? 'تحميل السيرة الذاتية (PDF)' : 'Download Executive CV')}</span>
      </button>

      {/* Secondary Action: Direct In-App Interactive Page */}
      <Link
        to={cvRoute}
        className="w-full sm:w-auto px-5 py-3.5 rounded-2xl bg-white/[0.05] hover:bg-white/[0.1] text-white border border-white/10 font-medium transition-all text-sm flex items-center justify-center gap-2 group"
      >
        <span>{lang === 'ar' ? 'عرض السيرة الذاتية' : 'View Online'}</span>
        <svg className="w-4 h-4 transform group-hover:translate-x-0.5 rtl:group-hover:-translate-x-0.5 transition-transform text-white/60" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
        </svg>
      </Link>
    </div>
  );
}

export default CVDownload;
